import { SET_ORDER } from './actionTypes';

import PickupOrder from '../../models/PickupOrder';

function setOrder(order: PickupOrder) {
  return {
    type: SET_ORDER,
    data: order
  }
}

function setOrderAction(order: PickupOrder) {

  return (dispatch: any) => {

    dispatch(setOrder(order));
  };
}

export {
  setOrderAction
};